import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

import { plants } from "@/data/plants";
import { garden } from "@/data/garden";
import { images } from "@/data/images";
import { Garden, Zone, Border, ZoneNames, BorderNames } from "./types";

type routerLink = { path: string } | null;

Vue.use(Vuex);

function findPlant(number: number, garden: Garden) {
  return Object.entries(garden.zones)
    .map(([name, zone]) => {
      if (!zone) {
        return [];
      }
      const borderNames = findPlantInZone(number, zone);
      if (borderNames.length > 0) {
        return borderNames
          .map((borderName) => ({ border: borderName, zone: name }))
          .flat();
      } else {
        return [];
      }
    })
    .flat();
}

function findPlantInZone(number: number, zone: Zone) {
  return Object.entries(zone.borders)
    .filter(([name, border]) => border && findPlantInBorder(number, border))
    .map(([name, border]) => name);
}

function findPlantInBorder(number: number, border: Border) {
  return border.plants.indexOf(number) > -1;
}

export default new Vuex.Store({
  plugins: [createLogger()],
  state: {
    plants: plants,
    plantTypes: [
      "vaste planten",
      "heesters",
      "klimplanten",
      "vijver- en moerasplanten",
      "bomen",
      "hagen",
      "groenten",
      "fruit",
    ],
    garden: garden,
    images: images,
    navigation: {
      up: null as routerLink,
      prev: null as routerLink,
      next: null as routerLink,
    },
  },
  getters: {
    findPlantInGarden: (state) => (number: number) =>
      findPlant(+number, state.garden),
    getPlantsByType: (state) => (type: string) =>
      Object.entries(state.plants).filter(
        ([number, plant]) => plant.type === type,
      ),
    searchPlants: (state) => (searchText: string) =>
      Object.entries(state.plants).filter(
        ([number, plant]) =>
          plant.name.toLowerCase().match(searchText.toLowerCase()) ||
          (plant.localName &&
            plant.localName.toLowerCase().match(searchText.toLowerCase())),
      ),
    getLocationName: (state) => (z: ZoneNames, b: BorderNames) => {
      const zone = (state.garden as Garden).zones[z]!;
      const border = zone.borders[b]!;
      return `${zone.alias}/${border.alias}`;
    },
  },
  mutations: {
    setNavigation(
      state,
      payload: { up: routerLink; prev: routerLink; next: routerLink },
    ) {
      state.navigation = payload;
    },
  },
  actions: {
    setNavigation(
      context,
      payload: { up: routerLink; prev: routerLink; next: routerLink },
    ) {
      context.commit("setNavigation", payload);
    },
  },
});
